const translations: Record<string, string> = {
  "ak_prices_uah_mwh_vs": "UAH/MWh · {{ym}} vs {{prev}}",
  "ak_prices_hour_00": "Hour {{h}}:00",
  "ak_prices_positive_imbalance_uah_mwh": "Positive imbalance: {{v}} UAH/MWh",
  "ak_prices_negative_imbalance_uah_mwh": "Negative imbalance: {{v}} UAH/MWh",
  "ak_prices_no_imbalance_prices_for": "No imbalance prices for {{d}}.",
  "ak_prices_no_dam_data_for": "No DAM data for {{d}}.",
  "ak_prices_prices_for_tomorrow_appear_today_at_12": "Prices for tomorrow appear today at 12:45-13:15 Kyiv time.",
  "ak_prices_uah_mwh": "{{n}} UAH/MWh",
  "ak_prices_mwh": "{{n}} MWh",
  "ak_prices_data_source_market_operator_jsc": "data source: Market Operator JSC",
  "ak_prices_source_market_operator_jsc": "source: Market Operator JSC",
  "ak_prices_source_npc_ukrenergo": "source: NPC Ukrenergo",
  "ak_prices_hour": "Hour",
  "ak_prices_chart": "Chart",
  "ak_prices_table": "Table",
  "ak_prices_min_positive": "Min. positive",
  "ak_prices_max_positive": "Max. positive",
  "ak_prices_min_negative": "Min. negative",
  "ak_prices_max_negative": "Max. negative",
  "ak_prices_loading": "Loading…",
  "ak_prices_balancing_market_price_uah_mwh": "Balancing market price, UAH/MWh",
  "ak_prices_positive_imbalance_uah_mwh_2": "Positive imbalance, UAH/MWh",
  "ak_prices_negative_imbalance_uah_mwh_2": "Negative imbalance, UAH/MWh",
  "ak_prices_positive_imbalance": "Positive imbalance",
  "ak_prices_negative_imbalance": "Negative imbalance",
  "ak_prices_price_uah_mwh": "Price, UAH/MWh",
  "ak_prices_volume_mwh": "Volume, MWh",
  "ak_prices_price": "Price",
  "ak_prices_volume": "Volume",
  "ak_prices_uah_mwh_vs_d_1": "UAH/MWh · vs D−1",
  "ak_prices_daily": "Daily",
  "ak_prices_day_8_23": "Day (8-23)",
  "ak_prices_night_1_7_24": "Night (1-7, 24)",
  "ak_prices_peak_18_23": "Peak (18-23)",
  "ak_prices_semi_peak_8_17": "Semi-peak (8-17)",
  "ak_prices_monthly": "Monthly",
  "ak_prices_dam_day_ahead": "DAM (day-ahead)",
  "ak_prices_bm_operational": "BM - operational",
  "ak_prices_bm_actual": "BM - actual",
  "ak_prices_market_prices": "Market, prices",
  "ak_prices_weighted_average_dam_prices": "Weighted average DAM prices",
  "ak_prices_hourly_dam_prices": "Hourly DAM prices",
  "ak_prices_operational_balancing_market_prices": "Operational Balancing Market prices",
  "ak_prices_actual_balancing_market_prices": "Actual Balancing Market prices",
  "ak_prices_actual_hourly_balancing_market_prices": "Actual hourly Balancing Market prices",
  "ak_prices_operational_hourly_balancing_market_pr": "Operational hourly Balancing Market prices",
  "ak_prices_prices": "Prices",
  "ak_prices_no_dam_data": "No DAM data.",
  "ak_prices_prices_for_tomorrow_appear_today_at_12_2": "Prices for tomorrow appear today at 12:45-13:15.",
};

export default translations;
